import { render, staticRenderFns } from "./OrderItemView.vue?vue&type=template&id=59437d28&scoped=true&"
import script from "./OrderItemView.vue?vue&type=script&lang=js&"
export * from "./OrderItemView.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemView.vue?vue&type=style&index=0&id=59437d28&scoped=true&lang=css&"
import style1 from "./OrderItemView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59437d28",
  null
  
)

export default component.exports